/**
 * RTK Query endpoints — Agent API keys
 *
 * Keys that let AI agents and integrations read the tenant through
 * /api/agent (REST + MCP). Served by @betterfield/mcp-express's
 * key-management router, mounted at /su/agent-keys behind the admin gate.
 * The secret of a new or rotated key is in the mutation's response only.
 */

import { baseApi } from './baseApi';
import { buildQueryString } from './utils';

const agentKeysApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /su/agent-keys — keys plus the scopes and tiers a key can have
    agentKeys: builder.query({
      query: () => ({ url: '/su/agent-keys', method: 'GET' }),
      providesTags: [{ type: 'AgentKey', id: 'LIST' }],
    }),

    // GET /su/agent-keys/audit — agent calls, newest first
    agentKeysAudit: builder.query({
      query: (params = {}) => ({ url: `/su/agent-keys/audit${buildQueryString(params)}`, method: 'GET' }),
      providesTags: [{ type: 'AgentKey', id: 'AUDIT' }],
      keepUnusedDataFor: 0,
    }),

    // POST /su/agent-keys
    createAgentKey: builder.mutation({
      query: (body) => ({ url: '/su/agent-keys', method: 'POST', body }),
      invalidatesTags: [{ type: 'AgentKey', id: 'LIST' }],
    }),

    // POST /su/agent-keys/:id/rotate
    rotateAgentKey: builder.mutation({
      query: ({ id, graceHours }) => ({ url: `/su/agent-keys/${id}/rotate`, method: 'POST', body: { graceHours } }),
      invalidatesTags: [{ type: 'AgentKey', id: 'LIST' }],
    }),

    // DELETE /su/agent-keys/:id
    revokeAgentKey: builder.mutation({
      query: (id) => ({ url: `/su/agent-keys/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'AgentKey', id: 'LIST' }],
    }),
  }),
});

export const {
  useLazyAgentKeysQuery,
  useLazyAgentKeysAuditQuery,
  useCreateAgentKeyMutation,
  useRotateAgentKeyMutation,
  useRevokeAgentKeyMutation,
} = agentKeysApi;
